import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { DataService, OperationsService } from '../../../_services/index';
import { HttpClient } from '@angular/common/http';
import { CustomerService, StorageService } from '../../../_services/index';

@Component({
  selector: 'app-popupcalendar',
  templateUrl: './popupcalendar.component.html',
  styleUrls: ['./popupcalendar.component.css']
})
export class PopupcalendarComponent implements OnInit {
  slave = '';
  state:any;
  currentUser: any;
  url: string = 'https://creditclanapis.creditclan.com/api/v2/dashboard';
  @Input('date_selected') date_selected: any;
  @Input('calendar_type') calendar_type: any;
  @Input('calendar_from') calendar_from: any = '1';
  @Output() openRequestEvent  = new EventEmitter();
  title = 'Approvals';
  day_approvals: any;
  request_tenor: any;
  loading = false;
  record_type = '1';
  schedule_type = false;
  start = '0';
  show_button: boolean = false;
  show_form: any;
  payment = {
    'AMOUNT':'',
    'PAYMENT_DATE':'',
    'REQUEST_ID':'',
    'SECURITY_QUESTION_ANSWER':''
  }
  constructor(
    private dataService: DataService,
    private http: HttpClient,
    public storageService: StorageService,
    private operationsService: OperationsService
  ) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.show_button = false;
  }
  getRecords(start) {
    this.loading = true;
    this.operationsService.getRepaymentsForTheDay(this.currentUser.token, this.record_type, this.schedule_type, this.date_selected, start)
      .subscribe(data => {
        this.loading = false;
        this.state = data;
      });
  }
  ngOnInit() {
    if (this.calendar_from === '7') {
      this.title = 'Repayments';
      this.getRecords(this.start);
    } else {
      if (this.calendar_from === '1') {
        this.getApprovalsForTheDay();
      } else { 
        if(this.calendar_type==='2'){
          this.title = 'Rejected Requests';
        }else{
          this.title = 'Eligible Requests';
        }
        //this.title = 'Requests';
        this.getRequestsForTheDay();
      }
    }

  }

  getDuration(request_period_id) {
    switch (request_period_id) {
      case '1':
        return 'days';
      case '2':
        return 'months';
      case '3':
        return 'years';
      case '4':
        return 'weeks';
    }
  }

  getInterest(request_period_id) {
    switch (request_period_id) {
      case '1':
        return '/d';
      case '2':
        return '/mo';
      case '3':
        return '/yr';
      case '4':
        return '/wk';
    }
  }

  getApprovalsForTheDay() {
    this.http.post<any>(`${this.url}/getApprovalsForTheDay`, {
      date_chosen: this.date_selected,
      token: this.currentUser.token
    }).subscribe(res => {
      if (res.status && res.has_data) {
        this.day_approvals = res.data;
      }
    });
  }

  getRequestsForTheDay() {
    this.http.post<any>(`${this.url}/getRequestsForTheDay`, {
      date_chosen: this.date_selected,
      token: this.currentUser.token,
      type: this.calendar_type
    }).subscribe(res => {
      if (res.status && res.has_data) {
        this.day_approvals = res.data;
      }
    });
  }
  showPaymentForm(i) {
    this.show_form = i;
  }
  openRequest(day_approval){
    this.openRequestEvent.emit({request: day_approval});
  }
  openPortfolio(day_approval){
    this.openRequestEvent.emit({request: day_approval});
  }
  saveInterestRateBand(value, valid, request_id){
    this.loading = true;
    this.operationsService.makepqueueThePaymentayment(this.currentUser.token, value, request_id)
      .subscribe(data => {
        this.loading = false;
        
      });
  }
  openModalSection(section, userId){ 
    //this.dataService.onOpenApplicationsModal.emit({ section: section, userId: userId });
  }
  openSidemenuForDueLoan(due){  
    this.dataService.openSidemenuForDueLoan.emit({due: due});
  }
}
